module.exports = __webpack_public_path__ + "img/scatter.d98514ba.png";